import { Injectable } from '@angular/core';
import { SingletonServiceGuard } from '@lsq-frontend/angular-shared/features/generic-get-services';
import { format } from 'date-fns';
import { DateFnsFormat } from '../../constants/date-format.constants';

@Injectable({ providedIn: 'root' })
export class Serializer {
    constructor() {
        SingletonServiceGuard.register('Serializer');
    }

    public deserialize<T>(str: string): T {
        return JSON.parse(str);
    }

    public serialize(obj: object): string {
        return JSON.stringify(this.mapDateObjectsToStrings(obj));
    }

    public mapDateObjectsToStrings(obj: object): object {
        const requestKeys = Object.keys(obj);
        requestKeys.forEach((key) => {
            if (obj[key] instanceof Date) {
                obj[key] = format(obj[key], DateFnsFormat.ApiDateTimeFormat);
            } else if (Array.isArray(obj[key])) {
                obj[key] = obj[key].map((item: any) => {
                    if (item instanceof Date) {
                        return format(item, DateFnsFormat.ApiDateTimeFormat);
                    } else if (this.isObject(item)) {
                        return this.mapDateObjectsToStrings(item);
                    }

                    return item;
                });
            } else if (this.isObject(obj[key])) {
                this.mapDateObjectsToStrings(obj[key]);
            }
        });

        return obj;
    }

    private isObject(value: any): boolean {
        return !!value && typeof value === 'object';
    }
}
